import { render, staticRenderFns } from "./CreateNewBenefit.vue?vue&type=template&id=229e7238"
import script from "./CreateNewBenefit.vue?vue&type=script&lang=js"
export * from "./CreateNewBenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports